import { ValueGetterFunc } from "ag-grid-community";
import { OffHoursSchedule } from "@/services/cloudchipr.api";
import { capitalizeString } from "@/utils/helpers/capitalizeString";
import { getCronFrequency } from "@/store/automations/utils/helpers/cron/getCronFrequency";

export const offHoursFrequencyValueGetter: ValueGetterFunc<
  OffHoursSchedule
> = ({ data }) => {
  if (!data) {
    return "-";
  }

  return data.start_cron
    ? capitalizeString(getCronFrequency(data.start_cron))
    : "Once";
};
